import PropTypes from "prop-types";
import { useState } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import MDBox from "theme/components/MDBox";

function MultiCheckboxField({ displayName, fieldRef, options }) {
  const [selected, setSelected] = useState([]);

  const handleChange = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  return (
    <MDBox>
      <MDBox mb={1}>{displayName}</MDBox>

      {options?.map((opt) => (
        <FormControlLabel
          key={opt.value}
          control={
            <Checkbox
              checked={selected.includes(opt.value)}
              onChange={() => handleChange(opt.value)}
            />
          }
          label={opt.label}
        />
      ))}

      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={JSON.stringify(selected)}
      />
    </MDBox>
  );
}

// Typechecking props
MultiCheckboxField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

MultiCheckboxField.defaultProps = {
  options: [],
};

export default MultiCheckboxField;
